import { render, staticRenderFns } from "./CommodityMarketingContent.vue?vue&type=template&id=24fb7a2d&scoped=true&"
import script from "./CommodityMarketingContent.vue?vue&type=script&lang=js&"
export * from "./CommodityMarketingContent.vue?vue&type=script&lang=js&"
import style0 from "./CommodityMarketingContent.vue?vue&type=style&index=0&id=24fb7a2d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fb7a2d",
  null
  
)

export default component.exports